<script setup lang="ts">
  import useCommonMixin from '@/composables/useCommonMixin'
  import { computed } from 'vue'
  import { UserModule } from '@/store/modules/user'
  import { CourseModule } from '@/store/modules/course'

  defineProps<{
    onCoursePanel?: boolean
  }>()

  const { formatDate } = useCommonMixin()

  const expired = computed(() => CourseModule.course?.expired)

  const expiredAt = computed(() => CourseModule.course?.expiredAt ?? null)

  const expiryDuration = computed(() => UserModule.company?.courseExpiryDuration)
</script>

<template lang="pug">
.course-expired-banner(v-if='expired && expiredAt', :class='{ "on-course-panel": onCoursePanel }')
  h5.ketch-font-bold(v-if='onCoursePanel') {{ $t('courses.expiredContent.yourAccessToPremiumContentHasExpired') }}
  h5 {{ $t('courses.expiredContent.courseExpiredInfo', { expiredDate: formatDate(expiredAt, 'dd.MM.yyyy'), expiryDuration: expiryDuration }) }}
  .service-contact(v-if='onCoursePanel')
    h5.ketch-font-bold {{ $t('courses.expiredContent.serviceContact') }}
    h5.ketch-space-x-c5
      span E-Mail:
      a(href='mailto:service@sachkundegurus.de') service@sachkundegurus.de
</template>

<style scoped lang="postcss">
  .course-expired-banner {
    @apply ketch-flex ketch-items-center ketch-justify-center ketch-w-full ketch-rounded-lg;
    @apply ketch-px-c10 ketch-py-c5 ketch-text-secondary-foreground-color ketch-bg-secondary-color;

    &.on-course-panel {
      @apply ketch-flex-col ketch-items-start ketch-space-y-c10 ketch-rounded-large ketch-p-c15;
      @apply sm:ketch-rounded-normal sm:ketch-p-c20;
    }

    &.on-module-lesson-layout {
      @apply ketch-mt-c15;
    }
  }
</style>
